import { configureStore, combineReducers } from '@reduxjs/toolkit';
import rootSlice from './rootSlice';

const rootReducer = combineReducers({
    root: rootSlice,
    
});

const store = configureStore({
    reducer: rootReducer,
    
});

export default store;
